var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner emailInputDialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Viewer.email"),
        width: "820px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "flex-direction": "column", margin: "0 auto" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isQuotation,
                  expression: "!isQuotation"
                }
              ]
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { no: "1" },
                  on: {
                    change: function($event) {
                      return _vm.changeHandler()
                    }
                  },
                  model: {
                    value: _vm.customerType,
                    callback: function($$v) {
                      _vm.customerType = $$v
                    },
                    expression: "customerType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Customer")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCmp")))
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.BookingAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 4 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.LocalAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 5 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.UpDestAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 6 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 7 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Haulage")))
                  ]),
                  _c("el-radio", { attrs: { label: 8 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Warehouse")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticStyle: {
                width: "fit-content",
                margin: "0 auto",
                "padding-top": "30px"
              },
              attrs: { "label-width": "100px", "label-position": "right" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Viewer.company") } },
                [
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isQuotation,
                        expression: "!isQuotation"
                      }
                    ],
                    attrs: {
                      no: "2",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params":
                        ((_obj = {}),
                        (_obj[_vm.customerTypeName] = true),
                        _obj),
                      filterable: "",
                      "default-value": _vm.customerId || ""
                    },
                    on: { parentCallBack: _vm.onLoad }
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isQuotation,
                        expression: "isQuotation"
                      }
                    ],
                    staticStyle: { width: "410px" },
                    attrs: { no: "3" },
                    model: {
                      value: _vm.txtAccount2,
                      callback: function($$v) {
                        _vm.txtAccount2 = $$v
                      },
                      expression: "txtAccount2"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Viewer.emailAddress") } },
                [
                  _c("cargo-combo-box", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isQuotation,
                        expression: "!isQuotation"
                      }
                    ],
                    staticStyle: { width: "410px" },
                    attrs: {
                      no: "4",
                      "allow-create": true,
                      clearable: true,
                      options: _vm.contactList,
                      "label-function": _vm.labelFunction,
                      "value-field": "email",
                      "forbid-values": [""]
                    },
                    on: { clear: _vm.onClear },
                    model: {
                      value: _vm.emailForm.to,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "to", $$v)
                      },
                      expression: "emailForm.to"
                    }
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isQuotation,
                        expression: "isQuotation"
                      }
                    ],
                    staticStyle: { width: "410px" },
                    attrs: { no: "5" },
                    model: {
                      value: _vm.txtTo2,
                      callback: function($$v) {
                        _vm.txtTo2 = $$v
                      },
                      expression: "txtTo2"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "6" },
                        on: {
                          change: function($event) {
                            return _vm.ccChangeHandler("sales", _vm.sales)
                          }
                        },
                        model: {
                          value: _vm.sales,
                          callback: function($$v) {
                            _vm.sales = $$v
                          },
                          expression: "sales"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "7" },
                        on: {
                          change: function($event) {
                            return _vm.ccChangeHandler("sales", _vm.op)
                          }
                        },
                        model: {
                          value: _vm.op,
                          callback: function($$v) {
                            _vm.op = $$v
                          },
                          expression: "op"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "8" },
                        on: {
                          change: function($event) {
                            return _vm.ccChangeHandler("sales", _vm.csr)
                          }
                        },
                        model: {
                          value: _vm.csr,
                          callback: function($$v) {
                            _vm.csr = $$v
                          },
                          expression: "csr"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerService")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "9" },
                        on: {
                          change: function($event) {
                            return _vm.ccChangeHandler("sales", _vm.doc)
                          }
                        },
                        model: {
                          value: _vm.doc,
                          callback: function($$v) {
                            _vm.doc = $$v
                          },
                          expression: "doc"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "10" },
                        model: {
                          value: _vm.defaultCc,
                          callback: function($$v) {
                            _vm.defaultCc = $$v
                          },
                          expression: "defaultCc"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SaveTheDefaultCC")))]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Viewer.cc") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "410px" },
                    attrs: { no: "11", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.emailForm.cc,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "cc", $$v)
                      },
                      expression: "emailForm.cc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Viewer.title") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "410px" },
                    attrs: { no: "12" },
                    model: {
                      value: _vm.emailForm.title,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "title", $$v)
                      },
                      expression: "emailForm.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.isCopyLink
                      ? _vm.$t("Viewer.BlAddress")
                      : _vm.$t("Viewer.content")
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "410px" },
                    attrs: {
                      no: "13",
                      type: "textarea",
                      rows: 5,
                      placeholder: _vm.isCopyLink
                        ? _vm.$t("Message.YouTheLinkAddressDirectly")
                        : ""
                    },
                    model: {
                      value: _vm.emailForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "content", $$v)
                      },
                      expression: "emailForm.content"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("queryJob.SendEmail"), inline: true }
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { no: "14" },
                      on: {
                        change: function($event) {
                          return _vm.statusChange()
                        }
                      },
                      model: {
                        value: _vm.checkList,
                        callback: function($$v) {
                          _vm.checkList = $$v
                        },
                        expression: "checkList"
                      }
                    },
                    _vm._l(_vm.sendEamilArr, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [_c("el-checkbox", { attrs: { label: item } })],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "15", type: "primary" },
              on: { click: _vm.localEmailClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("Viewer.InvokeLocalMailClient")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "16", disabled: !_vm.okEnable, type: "primary" },
              on: { click: _vm.okClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("Viewer.send")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "17" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("Viewer.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }